import { actions as workOrderReferenceActions, reducers as workOrderReferenceReducers } from './WorkOrderReference/WorkOrderReference.redux';
import { actions as workOrderSerialNumActions, reducers as workOrderSerialNumReducers } from './WorkOrderReference/WorkOrderMultiSerialNumber/WorkOrderSerialNumber.redux'
import { actions as workOrderViewAllActions, reducers as workOrderViewAllReducers } from './WorkOrderViewAll/WorkOrderViewAll.redux';

import { FileAddFilled } from '@ant-design/icons';
import React from 'react';
import { registerNavigation } from '@/core/navigation';
import { registerReduxStore } from '@/core/store';
import { registerRoutes } from '@/core/routes';
import WorkOrderReference from './WorkOrderReference/WorkOrderReference';
import WorkOrderViewAll from './WorkOrderViewAll/WorkOrderViewAll';

registerReduxStore('workOrderSerialNum', workOrderSerialNumReducers, workOrderSerialNumActions);
registerReduxStore('workOrderReference', workOrderReferenceReducers, workOrderReferenceActions);
registerReduxStore('workOrderViewAll', workOrderViewAllReducers, workOrderViewAllActions);

registerRoutes([
	{
		path: '/work-orders/reference',
		exact: true,
		render: <WorkOrderReference />,
		title: 'Work Orders - Reference',
		private: true,
		permissions: ['prod_permissions_read'],
	},
	// Disabled these pages its being replicated in the planner/scheduler
	// {
	// 	path: '/work-orders/reference/:docNum',
	// 	exact: true,
	// 	render: <WorkOrderReference />,
	// 	title: 'Work Orders - Reference',
	// 	private: true,
	// 	permissions: ['prod_permissions_read'],
	// },
	// {
	// 	path: '/work-orders/view-all',
	// 	exact: true,
	// 	render: <WorkOrderViewAll />,
	// 	title: 'Work Orders - View All',
	// 	private: true,
	// 	permissions: ['prod_permissions_read'],
	// },

]);


registerNavigation({
	title: 'Work Orders',
	top: true,
	home: true,
	icon: <FileAddFilled />,
	permissions: ['prod_permissions_read'],
	// Planner and Scheduler children are injected by the nondev/planner and
	// nondev/scheduler plugins via registerNavChild('Work Orders', ...).
	children: [
		// {
		// 	title:       'Reference',
		// 	url:         '/work-orders/reference',
		// 	permissions: ['prod_permissions_read' ],
		// },
		// {
		// 	title:       'View All',
		// 	url:         '/work-orders/view-all',
		// 	permissions: ['prod_permissions_read' ],
		// },
	],
});


console.log('Registered Work Order Tool Plugin');
